import React = require("react");
import Select from "react-select";
import Slider from "react-slick";
import { ready } from "../../../../custom_api/api_utils";
import { SearchOn } from "../../../../custom_api/collection/types";
import { pushBookBasedInspirationAction } from "../../datalayer";
import { Link } from "../../library/link";
import { Loader } from "../../loader";
import { scrollAdviceIntoView } from "../Advice/Advice";
import { customSelectStyles, customSelectTheme } from "../Shared/AsyncSelectStyles";
import { InspirationBaseSelector, inspirationLabelsWeb } from "../Shared/InspirationBaseSelector";
import { InspirationWrapper as InspirationWrapperWeb } from "../Shared/InspirationWrapperWeb";
import { BookBasedInspirationLayoutProps } from "./BookBasedInspirationState";
import { setCustomArrowsFocus } from "../../quick_links";

export const BookBasedInspirationLayoutWeb = (props: BookBasedInspirationLayoutProps) => {
  const { prompts, collectionPage, routePath, searchResults, searchQuery, updateSearchQuery, pickBook } = props

  return (
    <div className="inspiration-page ip ip--book-based-inspiration" key="BookBasedInspirationLayout">
      {collectionPage.kind != "loaded" ? <Loader /> :
        <InspirationWrapperWeb
          {...{ ...collectionPage.value, pageTitle: `${collectionPage.value.pageTitle} - Aanraders` }}
        >
          <div className="ip__content">
            <div className="container--m">
              <h2 className="ip__title title--l">Inspiratie nodig?</h2>
              <p className="ip_description description--l">
                Heb je hulp nodig met het ontdekken van je volgende boek? Kijk dan hieronder.
                Klik op een boek dat je leuk lijkt en reserveer het direct bij jouw bibliotheek.
              </p>
              <InspirationBaseSelector activeBase="book" routePath={routePath} labels={inspirationLabelsWeb} />
              <div className="searchbar--theme">
                <div className="searchbar__inner">
                  <h2 className="searchbar__title">Heb je een boek dat je goed vindt? Ontdek boeken die er op lijken</h2>
                  <div className="searchbar__input">
                    <Select<SearchOn>
                      className="searchbar__select react-select"
                      classNamePrefix="react-select"
                      placeholder="Zoek een boek"
                      styles={customSelectStyles}
                      theme={(theme) => customSelectTheme(theme)}
                      noOptionsMessage={() => 'Geen suggesties gevonden.'}
                      isClearable={true}
                      onInputChange={updateSearchQuery}
                      onChange={pickBook}
                      inputValue={searchQuery}
                      options={ready(searchResults) ? searchResults.value : []}
                      onMenuOpen={ () => {} }
                      onMenuClose={ () => {} }
                      value={undefined}
                      />
                  </div>
                </div>
              </div>
              {prompts.kind != 'loaded' ? <Loader /> :
                <>
                  <div className="layout layout--sc-column">
                    <div className="layout__sidebar">
                      <div className="layout__header ip__header--bookslider">
                        <h2 className="layout__title layout__title--center title--s">{
                          "Of kies één van deze boeken als startpunt"
                        }
                        </h2>
                      </div>

                      <Slider {... {
                        accessibility: true,
                        dots: true,
                        arrows: true,
                        infinite: false,
                        variableWidth: true,
                        className: "bookslider",
                        dotsClass: "bookslider-dots",
                        speed: 500,
                        swipeToSlide: true,
                        slidesToShow: 8,
                        slidesToScroll: 8,
                        responsive: [
                          {
                            breakpoint: 1095,
                            settings: {
                              slidesToShow: 7,
                              slidesToScroll: 7,
                            }
                          },
                          {
                            breakpoint: 964,
                            settings: {
                              slidesToShow: 6,
                              slidesToScroll: 6,
                            }
                          },
                          {
                            breakpoint: 833,
                            settings: {
                              slidesToShow: 5,
                              slidesToScroll: 5
                            }
                          },
                          {
                            breakpoint: 702,
                            settings: {
                              slidesToShow: 4,
                              slidesToScroll: 4
                            }
                          },
                          {
                            breakpoint: 571,
                            settings: {
                              slidesToShow: 3,
                              slidesToScroll: 3
                            }
                          },
                          {
                            breakpoint: 440,
                            settings: {
                              slidesToShow: 2,
                              slidesToScroll: 2
                            }
                          }
                        ],
                        onReInit: () => {
                          const slides = document.querySelectorAll('.slick-slide');
                          slides.forEach((slide) => {
                            slide.setAttribute('aria-hidden', 'false')
                          })
                          setCustomArrowsFocus()
                          const dots = document.querySelectorAll('.bookslider-dots li');
                          if (dots == null || dots.length == 0) { return; }
                          dots.forEach((dot, key) => {
                            if (dot.classList.contains('slick-active')) { dot.setAttribute('aria-current', 'true') }
                            else { dot.removeAttribute('aria-current') }
                          })
                        },
                        slickPrev: () => {
                          setCustomArrowsFocus()
                        },
                        slickNext: () => {
                          setCustomArrowsFocus()
                        },
                        customPaging: (i) => (
                          <button tabIndex={-1}>
                            <span className="sr-txt">Navigeer naar pagina {i + 1} van carousel</span>
                            <span aria-hidden="true">{i + 1}</span>
                          </button>
                        )
                      }}>
                        {prompts.value.map(b => {
                          const titleAndAuthor = `${b.title} - ${b.author}`
                          return <div key={`prompt-${b.isbn}`} className={`bookslider-item`}>
                            <Link
                              className="bookcover bookcover--small"
                              url={`/${routePath}/boek/${b.isbn}`}
                              title={titleAndAuthor}
                              handle={() => {
                                pushBookBasedInspirationAction("Klik op boek suggestie", titleAndAuthor);
                                scrollAdviceIntoView();
                              }}
                            >
                              <div className="bookcover__inner">
                                <img className="bookcover__image" src={`${b.cover}size=111`} srcSet={`${b.cover}size=110 1x, ${b.cover}size=220 2x`} alt={titleAndAuthor} loading="lazy" width="110" height="170" />
                              </div>
                            </Link>
                          </div>
                        })}
                      </Slider>
                    </div>
                  </div>
                </>
              }
            </div>
          </div>
        </InspirationWrapperWeb>
      }
    </div>)
}